import { IModalDialogOptions } from '@app/shared/types';
import { BTN_CANCEL, BTN_SAVE } from '@app/text-content/button-templates';
import { MODAL_SAVE_AS_TEMPLATE_CONFIRM } from '@app/text-content/modal-templates';
import { TransferGroupTemplateService } from '@app/shared/services/transfer-group-template/transfer-group-template.service';
import { ValidationService } from '..';

export const saveAsTemplateModalOptions = (
  templateService: TransferGroupTemplateService,
): IModalDialogOptions => ({
  ...MODAL_SAVE_AS_TEMPLATE_CONFIRM(
    templateService,
    ValidationService.PATTERNS.STRING_WITHOUT_SPECIAL_CHARACTERS,
    templateService.i18nService,
  ),
  buttons: [
    {
      ...BTN_SAVE,
    },
    BTN_CANCEL,
  ],
});
